export const matchesMimeType = (
  value: string | null,
  mimeTypes: readonly string[],
): boolean => {
  return value !== null && mimeTypes.includes(value);
};
